import { property } from 'lit/decorators.js';

import { XdsCoreButton } from '@cof/xds-core-button';
import { DxoStylesButton } from './DxoStylesButton';

export class DxoUiButton extends XdsCoreButton {
  @property({ type: String, attribute: 'type' }) type = 'button';
  @property({ type: String, attribute: 'delegated-aria-label', reflect: false }) ariaLabel: string | null = null;
  @property({ type: String, attribute: 'delegated-aria-labelledby', reflect: false }) ariaLabelledby: string | null = null;
  @property({ type: String, attribute: 'delegated-aria-describedby', reflect: false }) ariaDescribedby: string | null = null;
  @property({ type: String, attribute: 'delegated-role', reflect: false }) role: string | null = null;

  static styles: any = [DxoStylesButton];
  constructor() {
    super();
    this.styleVariant = 'button-primary';
  }

  updated(changedProperties: Map<string, any>): void {
    super.updated(changedProperties);
    
    const buttonElement = this.shadowRoot?.querySelector('button');
    if (buttonElement) {
      // Apply ARIA attributes to the button element
      if (this.ariaLabel) {
        buttonElement.setAttribute('aria-label', this.ariaLabel);
      } else {
        buttonElement.removeAttribute('aria-label');
      }
      
      if (this.ariaLabelledby) {
        buttonElement.setAttribute('aria-labelledby', this.ariaLabelledby);
      } else {
        buttonElement.removeAttribute('aria-labelledby');
      }
      
      if (this.ariaDescribedby) {
        buttonElement.setAttribute('aria-describedby', this.ariaDescribedby);
      } else {
        buttonElement.removeAttribute('aria-describedby');
      }
      
      if (this.role) {
        buttonElement.setAttribute('role', this.role);
      } else {
        buttonElement.removeAttribute('role');
      }
    }
  }

  firstUpdated(): void {
    super.firstUpdated();
    document.addEventListener('keypress', (event: KeyboardEvent) => {
      if (event.key === 'Enter' && this.type.toLowerCase() === 'submit' && !this.isDisabled) {
        this._onClick(event);
      }
    });
  }

  _onClick(event: any) {
    if (event instanceof Event) {
      event.stopPropagation();
    }

    const eventToBeEmitted = new CustomEvent('click', {
      detail: {
        source: 'dxo-ui-button',
        eventType: 'click',
        keyPressed: event != null ? event.keyCode : '',
        id: this.getId(),
      },
    });
    this.dispatchEvent(eventToBeEmitted);
  }
}